import { BASE_URL } from '../../constants';

// Each account's plan as the server resolves it (POST admin/users/plans/,
// users/admin_plan_views.py), for the Users page and Payments > Manage
// tiers. The stored subscription fields are not the plan: an athlete covered
// by their team's coach is Premium with no tier of their own, and a plan
// CACHE set up past its end date or an access grant past its end is Free.
//
// Answers { [email]: { role, entitlement, ownEntitlement, source, label,
// coverage, endsAt } } for the emails the server found and the caller may
// read. Best effort: a refusal or a failure answers what was read so far
// (often {}), so the pages fall back to the stored fields. Never throws.

export const PLANS_PER_REQUEST = 500;

export const fetchUserPlans = async (emails, token) => {
  const unique = [...new Set((emails || []).filter((e) => typeof e === 'string' && e.trim()))];
  const found = {};
  const auth = token || localStorage.getItem('token');
  try {
    for (let i = 0; i < unique.length; i += PLANS_PER_REQUEST) {
      // eslint-disable-next-line no-await-in-loop
      const res = await fetch(`${BASE_URL}/api/users/admin/users/plans/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${auth}` },
        body: JSON.stringify({ emails: unique.slice(i, i + PLANS_PER_REQUEST) }),
      });
      if (!res || !res.ok) break;
      // eslint-disable-next-line no-await-in-loop
      const data = await res.json();
      Object.entries(data && typeof data === 'object' ? data : {}).forEach(([email, plan]) => {
        if (plan && typeof plan === 'object' && plan.entitlement) found[email] = plan;
      });
    }
  } catch (err) {
    // The pages keep the stored fields.
  }
  return found;
};
